import { Roles } from '../../../constants';

import type { IProvider } from '../../../utils/types';

export function isTreatmentPlanReassignmentCandidate(provider: IProvider): boolean {
  return Boolean(provider.roles?.includes(Roles.Bcba));
}

export function reassignmentProviderLabel(provider: IProvider): string {
  return provider.is_reviewer_bcba
    ? `${provider.first_name} ${provider.last_name} (Reviewer BCBA)`
    : `${provider.first_name} ${provider.last_name}`;
}
